import lodash from 'lodash';
import {
    call, put, takeEvery, select, all,
} from 'redux-saga/effects';
import { LEAD_SOURCE_LEADOMATIC } from '../../../../../common/constants';
import { GET_CUSTOMERS_LIST_DATA, SET_CUSTOMERS_LIST_DATA } from '../../constants';
import { getLeads as getLeadsReq, countLeads as countLeadsReq } from '../../requests/leads.requests';


function* getLeads({ isCount, urlFilters }) {
    const store = yield select();
    const userDivisions = lodash.get(store, 'App.App_content.user.divisions') || [];
    const { pagination } = store.Leads.CustomersList;
    let divisionsIds = userDivisions.map((division) => division._id).filter((item) => item !== LEAD_SOURCE_LEADOMATIC);
    const urlDivisionId = lodash.get(urlFilters, 'divisionId');
    const urlCustomerPhone = lodash.get(urlFilters, 'customerPhone');

    yield put({
        type: SET_CUSTOMERS_LIST_DATA,
        payload: {
            isLoading: true,
            data: [],
        },
    });

    if (urlDivisionId) {
        divisionsIds = divisionsIds.includes(urlDivisionId) ? [urlDivisionId] : [];
    }

    const requestParams = {
        limit: pagination.rpp,
        offset: pagination.offset,
        customerPhone: urlCustomerPhone,
        ref_lead_source: divisionsIds,
    };

    const calls = {
        getLeadsRes: call(getLeadsReq, requestParams),
        countLeadsRes: isCount && call(countLeadsReq, requestParams),
    };

    const { getLeadsRes, countLeadsRes } = yield all(calls);
    const storePayload = {
        type: SET_CUSTOMERS_LIST_DATA,
        payload: {
            isLoading: false,
            data: getLeadsRes.result ? getLeadsRes.options : [],
            error: getLeadsRes.error,
        },
    };

    if (isCount) {
        storePayload.payload.dataCount = countLeadsRes.options.amount;
    }

    yield put(storePayload);
}

export default function* getLeadsSaga() {
    yield takeEvery(GET_CUSTOMERS_LIST_DATA, getLeads);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/CustomersList/redux/sagas/leads.saga.js